<template>
  <div>
    <b-card class="m-3">
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">Importar arquivo XML</span>
          <btn-voltar />
        </h6>
      </template>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(importarXml)">
          <b-row>
            <b-col>
              <validation-provider rules="required" v-slot="validationContext" name="arquivo">
                <b-form-group class="formGroup mb-5" id="arquivo-input-group" label="Arquivo (.zip)*"
                  label-for="input-arquivo" label-cols="auto" content-cols="4">
                  <b-form-file v-model="arquivo" :state="getValidationState(validationContext)"
                    placeholder="Escolha um arquivo..." drop-placeholder="Solte o arquivo aqui..." class=""
                    browse-text="Escolher" accept=".zip"></b-form-file>
                  <b-form-invalid-feedback id="input-arquivo-live-feedback">{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <div v-if="temCargosNaoImportados" class="cargosNaoImportadosWrapper">
            <b-button style="width: 300px" @click="baixarRelatorioDeInconsistencias()">
              <font-awesome-icon icon="file-alt" class="mr-2" />Relatório de inconsistencias
            </b-button>
            <div v-if="items.length > 0">
              <span class="mt-3"><b>Cargos não Importados</b></span>
              <b-table class="mt-3" :fields="fields" striped hover no-border-collapse :items="items" small>
              </b-table>
              <table-pagination :total-rows="items.length" :per-page="perPage" @pageChange="pageChange">
              </table-pagination>
            </div>
          </div>
          <b-row>
            <b-col>
              <b-button class="ml-4 mr-4" type="submit">
                <font-awesome-icon icon="file-upload" class="mr-2" />Enviar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import cargoService from '@/services/atos-pessoal/cargoService';
import TablePagination from '@/components/atos-pessoal/TablePagination.vue';
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import { UtilsTS } from '@/utilsts';

export default {
  name: "importar-xml-cargo",
  mixins: [UtilsTS],
  components: {
    ValidationProvider,
    ValidationObserver,
    TablePagination,
    BtnVoltar
  },

  data() {
    return {
      arquivo: null,
      temCargosNaoImportados: false,
      errosValidacao: null,
      perPage: 10,
      currentPage: 1,
      items: [],
      fields: [
        {
          key: "codigo",
          label: "Código",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "nomenclatura",
          label: "Nomenclatura",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "quantidadeVagas",
          label: "Quantidade de Vagas",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    voltar() {
      this.$router.go(-1);
    },

    async importarXml() {
      this.items = [];
      this.temCargosNaoImportados = false;
      const response = await cargoService.importarXml(this.arquivo);
      if (response && response.status == 200) {
        //mostrar mensagem de sucesso
        this.$toast.success('Arquivo importado com sucesso');
        this.$router.push('/atos-pessoal/cargos/consulta');
      }
      else {
        if (response && response.data.cargosNaoImportados) this.items = response.data.cargosNaoImportados;
        this.temCargosNaoImportados = true;
        if (response) this.errosValidacao = response.data;
        this.$toast.error('Erro ao processar o arquivo enviado');
      }
      this.$refs.observer.reset();
      this.arquivo = null;
    },

    async baixarRelatorioDeInconsistencias() {
      const response = await cargoService.baixarRelatorioDeInconsistencias(this.errosValidacao);
      if (response && response.status == 200)
        this.download("relatorio-de-inconsistencias-cargos.pdf", response.data);
      else {
        this.$toast.error('Erro ao baixar o relatório de inconsistências');
      }
    },

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    pageChange(value) {
      this.currentPage = value;
    },
  },
};
</script>

<style>
.formGroup {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.addNormativoBtnWrapper {
  display: flex;
}

.invalid-feedback {
  text-align: left;
}

.cargosNaoImportadosWrapper {
  display: flex;
  flex-direction: column;
}
</style>
